import {assertAndContinue} from 'Asserts';
import {getAccessibleOrInaccessibleId, isInaccessible} from 'graphql-client/InaccessibleInfo';

import {AnalyticsParameterValueTemplateGraphQL} from '../../../../graphql-fragments/insights/__generated/AnalyticsParameterValueTemplateGraphQL';
import {RESTAnalyticsParameterValueTemplate} from '../RESTEmbeddingTypes';

export function convertGQLToRESTParameterValueTemplate(
  gqlParameterValueTemplate: AnalyticsParameterValueTemplateGraphQL
): RESTAnalyticsParameterValueTemplate {
  assertAndContinue(
    !isInaccessible(gqlParameterValueTemplate.config),
    'Cannot convert inacessible value template to REST'
  );
  return {
    valueOperation: gqlParameterValueTemplate.valueOperation,
    valueJson: gqlParameterValueTemplate.valueJson,
    configId: getAccessibleOrInaccessibleId(gqlParameterValueTemplate.config),
  };
}
